const STORAGE_KEY = 'rs-session-id'

function createId() {
  if (crypto.randomUUID) return crypto.randomUUID()
  return Array.from(crypto.getRandomValues(new Uint8Array(16)), (byte) =>
    byte.toString(16).padStart(2, '0'),
  ).join('')
}

export function getSessionId() {
  try {
    let id = sessionStorage.getItem(STORAGE_KEY)
    if (!id) {
      id = createId()
      sessionStorage.setItem(STORAGE_KEY, id)
    }
    return id
  } catch (e) {
    return createId()
  }
}
